export const FEATURES = {
  SHOP: {
    ID: '', // Will be determined in the future
    NAME: 'shop',
  },
};

export const COMPONENT_NAMES = {
  APPS: {
    CHECKOUT_V3: {
      DELIVERY: 'CheckoutV3 - Delivery',
      SHIP_TO_ME: 'CheckoutV3 - Ship to Me',
      SHIPPING_RATES: 'CheckoutV3 - Shipping Rates',
      PAYMENT: 'CheckoutV3 - Payment',
      PAY_IN_FULL: 'CheckoutV3 - Pay in Full',
      PAY_IN_INSTALLMENTS: 'CheckoutV3 - Pay in Installments',
      INSTALLMENT_OFFERS: 'CheckoutV3 - Installment Offers',
      COMPLETING_GENERAL_ERROR: 'CheckoutV3 - Completing General Error',
      COMPLETING_PAYMENT_ERROR: 'CheckoutV3 - Completing Payment Error',
      COMPLETING_PRE_AUTH_ERROR: 'CheckoutV3 - Pre Auth Error',
      ORDER_COMPLETE: 'CheckoutV3 - Order Complete',
      PICK_UP_IN_STORE: 'CheckoutV3 - Pick up in Store',
      PICKUP_OPTIONS: 'CheckoutV3 - Pickup Options',
    },
  },
};

export const CHECKOUT_STEP_MAP = {
  [COMPONENT_NAMES.APPS.CHECKOUT_V3.DELIVERY]: 1,
  [COMPONENT_NAMES.APPS.CHECKOUT_V3.SHIP_TO_ME]: 2,
  [COMPONENT_NAMES.APPS.CHECKOUT_V3.SHIPPING_RATES]: 3,
  [COMPONENT_NAMES.APPS.CHECKOUT_V3.PAYMENT]: 4,
  [COMPONENT_NAMES.APPS.CHECKOUT_V3.PAY_IN_FULL]: 5,
  [COMPONENT_NAMES.APPS.CHECKOUT_V3.PAY_IN_INSTALLMENTS]: 6,
  [COMPONENT_NAMES.APPS.CHECKOUT_V3.INSTALLMENT_OFFERS]: 7,
  [COMPONENT_NAMES.APPS.CHECKOUT_V3.COMPLETING_GENERAL_ERROR]: 8,
  [COMPONENT_NAMES.APPS.CHECKOUT_V3.COMPLETING_PAYMENT_ERROR]: 9,
  [COMPONENT_NAMES.APPS.CHECKOUT_V3.COMPLETING_PRE_AUTH_ERROR]: 10,
  [COMPONENT_NAMES.APPS.CHECKOUT_V3.ORDER_COMPLETE]: 11,
  [COMPONENT_NAMES.APPS.CHECKOUT_V3.PICK_UP_IN_STORE]: 12,
  [COMPONENT_NAMES.APPS.CHECKOUT_V3.PICKUP_OPTIONS]: 13,
};

export const CHECKOUT_PAGE_CLICK_EVENTS = {
  address_validation_original: 'CheckoutV3 - Address validation use original',
  address_validation_corrected: 'CheckoutV3 - Address validation use corrected',
  shipping_rates_select: 'CheckoutV3 - Shipping rates select',
  delivery_page_complete_order: 'CheckoutV3 - Delivery page complete order',
  delivery_page_continue_to_payment:
    'CheckoutV3 - Delivery page continue to payment',
  payment_edit_accessory: 'CheckoutV3 - Payment edit accessory',
  billing_address_same: 'CheckoutV3 - Billing address same as shipping',
  billing_address_different:
    'CheckoutV3 - Billing address different from shipping',
  save_card_enabled: 'CheckoutV3 - Saved cards enabled',
  save_card_disabled: 'CheckoutV3 - Saved cards disabled',
  default_card_enabled: 'CheckoutV3 - Default card enabled',
  default_card_disabled: 'CheckoutV3 - Default card disabled',
  click_selected_saved_card: 'CheckoutV3 - Click selected saved card',
  select_saved_card: 'CheckoutV3 - Select save card',
  delete_saved_card: 'CheckoutV3 - Delete saved card',
  offer_select: 'CheckoutV3 - Offer select',
  payment_page_cta_installments: 'CheckoutV3 - Payment page CTA installments',
  payment_page_cta_pay_in_full: 'CheckoutV3 - Payment page CTA pay in full',
  completing_order_error_return_to_checkout:
    'CheckoutV3 - Completing order error return to checkout',
  installments_denied_return_to_checkout:
    'CheckoutV3 - Installments denied return to checkout',
  installments_pending_return_to_checkout:
    'CheckoutV3 - Installments pending return to checkout',
  financing_disclosure_review: 'CheckoutV3 - Financing disclosure review',
  financing_disclosure_complete_order:
    'CheckoutV3 - Financing disclosure complete order',
  financing_disclosure_return_to_checkout:
    'CheckoutV3 - Financing disclosure return to checkout',
  financing_dob_field_click: 'CheckoutV3 - Financing dob field click',
  financing_ssn_field_click: 'CheckoutV3 - Financing ssn field click',
  pickup_postal_code_change: 'CheckoutV3 - Pickup postal code change',
  pickup_option_select: 'CheckoutV3 - Pickup option select',
  nav_back_to_cart_on_delivery: 'CheckoutV3 - Nav back to cart on delivery',
  nav_back_to_delivery_on_payment:
    'CheckoutV3 - Nav back to delivery on payment',
  card_form_focus_added: 'CheckoutV3 - Card form focus added',
  card_form_focus_removed: 'CheckoutV3 - Card form focus removed',
  card_form_error_added: 'CheckoutV3 - Card form error added',
  card_form_error_removed: 'CheckoutV3 - Card form error removed',
  card_form_postal_code_change: 'CheckoutV3 - Card form postal code change',
  google_pay_button_click: 'CheckoutV3 - Google Pay button click',
  apple_pay_button_click: 'CheckoutV3 - Apple Pay button click',
  cash_app_pay_button_click: 'CheckoutV3 - Cash App Pay button click',
};
